import NiceModal from '@ebay/nice-modal-react';
import userflow from 'userflow.js';

import { memo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import OnboardingVideo from 'pages/Home/Onboarding/OnboardingVideo';

import { ONBOARDING } from 'services/consts';

import { updateInstructionData } from 'stores/InstructionSlice';
import { toogleSideBar } from 'stores/layoutSlice';

import AppLogger from 'utils/AppLogger';

import GlobalAlert from '../GlobalAlert/GlobalAlert';
import HelpButton from '../HelpButton/HelpButton';
import SideBar from '../SideBar/SideBar';
import TopBar from '../TopBar/TopBar';
import * as S from './AppLayout.styled';

const AppLayout = (props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const axiosPrivate = useAxiosPrivate();
	const sideBarOpen = useSelector((state) => state.layout.sideBarOpen);
	const onboarding = useSelector((state) => state.instruction);

	const onboardingInputRef = useRef(null);
	const pageInputRef = useRef(null);

	const handleSubmit = (event) => {
		event.preventDefault();
		axiosPrivate
			.post(ONBOARDING.UPDATE_ONBOARDING, {
				qualificationJSON: onboardingInputRef.current.value
			})
			.then((response) => {
				if (response.status === 200) {
					dispatch(
						updateInstructionData({
							isQualifiedUser: true,
							qualificationJSON: JSON.parse(onboardingInputRef.current.value)
						})
					);
				} else {
					AppLogger.error(response);
				}
			})
			.catch((error) => {
				AppLogger.error(error);
			});
	};

	const handleChangePage = (event) => {
		event.preventDefault();
		navigate(pageInputRef.current.value);
	};

	const showMonetizeVideo = () => {
		if (!onboarding.monetizedIntroVideo) {
			axiosPrivate.post(ONBOARDING.GET_VIDEO_REWARD).then((response) => {
				const { status, data } = response;
				if (status === 200) {
					const { reward, currency, videoUrl } = data;
					if (reward && currency && videoUrl) {
						const parsedUrl = JSON.parse(videoUrl);
						NiceModal.show(OnboardingVideo, { rewardData: { ...response.data, videoUrl: parsedUrl } });
						userflow.closeResourceCenter();
					}
				}
			});
		}
	};

	return (
		<>
			<S.Container>
				<SideBar />
				<S.Column>
					<S.MobileShadow isopen={sideBarOpen} onClick={() => dispatch(toogleSideBar())} />
					<TopBar />
					<GlobalAlert />
					<S.Main>{props.children}</S.Main>
				</S.Column>
				<HelpButton />
			</S.Container>
			<form
				style={{
					display: 'none'
				}}
				onSubmit={handleSubmit}>
				<input id="OnboardingInput" ref={onboardingInputRef} type="hidden" value="" />
				<button id="OnboardingButton" type="submit" />
			</form>
			<form
				style={{
					display: 'none'
				}}
				onSubmit={handleChangePage}>
				<input id="PageInput" ref={pageInputRef} type="hidden" value="" />
				<button id="PageSubmitButton" type="submit" />
			</form>
			<button id="MonetizeVideoButton" style={{ display: 'none' }} onClick={showMonetizeVideo} />
		</>
	);
};

export default memo(AppLayout);
